import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { lastHome } from '../lib/prefs.js';

/** Switching is instant: every home is already streaming, so this is just navigation. */
export function useSwitchHome(): (home: string) => void {
  const navigate = useNavigate();
  return useCallback(
    (home: string) => {
      lastHome.set(home);
      navigate(`/h/${home}`);
    },
    [navigate],
  );
}
